export default function getTourFlightAirportsKey(tourId: string, departureId: string): string {
  return `${tourId}:${departureId}`
}
